import { ICreateContratoUseCase } from "../../../presentation/useCases/create/create_contrato_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// CreateContratoUseCase


export class CreateContratoUseCase implements ICreateContratoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async createContrato(Status: number | null, NumeroContrato: string | null, Escopo: string | null, DataDe: Date | null, DataAte: Date | null, IdCentroCusto: number | null, IdFornecedor: number | null, StatusPcmat: number | null, StatusPcmso: number | null, ValorContrato: number | null, ValorMedido: number | null, ValorRestante: number | null, ContratoAssinado?: string | null): Promise<number> {
    
    const response =  await this.repository.createContrato(
      Status, NumeroContrato, Escopo, DataDe, DataAte, IdCentroCusto, IdFornecedor, StatusPcmat, StatusPcmso, ValorContrato, ValorMedido, ValorRestante, ContratoAssinado
    );
    return response.idContrato;
  }
}
